import {
  ArrowDown,
  ArrowLeft,
  ArrowRight,
  ArrowUp,
  ArrowUpRight,
  AudioLines,
  BookOpen,
  Box,
  Building2,
  Camera,
  Coffee,
  Columns2,
  DoorOpen,
  ExternalLink,
  Eye,
  FileText,
  FlaskConical,
  Footprints,
  GalleryHorizontalEnd,
  Globe,
  GraduationCap,
  CircleHelp,
  Image as ImageIcon,
  Info,
  ClipboardList,
  Landmark,
  LogIn,
  LogOut,
  MapPin,
  MessageSquare,
  Pentagon,
  Play,
  Star,
  Text,
  ToggleLeft,
  Trees,
  Video,
  Volume2,
  Accessibility,
  AlertTriangle,
  Apple,
  Armchair,
  ArrowDownLeft,
  ArrowDownRight,
  ArrowUpLeft,
  Baby,
  Ban,
  Bath,
  BedDouble,
  Bell,
  Bike,
  Binoculars,
  Bird,
  Brush,
  Bug,
  Bus,
  Calendar,
  Car,
  Castle,
  Cat,
  ChevronsUp,
  Church,
  Clapperboard,
  Clock,
  Compass,
  CookingPot,
  CornerUpLeft,
  CornerUpRight,
  Cross,
  Crown,
  CupSoda,
  Dice5,
  Dog,
  DoorClosed,
  Drama,
  Droplet,
  Factory,
  Film,
  FireExtinguisher,
  Fish,
  Flag,
  Flame,
  Flower2,
  Fuel,
  Gamepad2,
  Gem,
  Ghost,
  Gift,
  Guitar,
  Hammer,
  Headphones,
  Heart,
  HeartPulse,
  Home,
  Hospital,
  Hotel,
  KeyRound,
  Lamp,
  Library,
  Lightbulb,
  Lock,
  Map,
  Medal,
  Mic,
  Microwave,
  Milestone,
  Monitor,
  Moon,
  Mountain,
  Music,
  Navigation,
  Newspaper,
  Package,
  Palette,
  PawPrint,
  PersonStanding,
  Phone,
  Piano,
  Pizza,
  Plane,
  Printer,
  Puzzle,
  Rabbit,
  Recycle,
  Refrigerator,
  Rocket,
  Route,
  School,
  Shield,
  Ship,
  ShoppingCart,
  ShowerHead,
  Signpost,
  Siren,
  Snowflake,
  Sofa,
  Sparkles,
  Stethoscope,
  Store,
  Sun,
  Telescope,
  Tent,
  Ticket,
  TrainFront,
  Trash2,
  TreePine,
  Trophy,
  Turtle,
  Tv,
  Umbrella,
  User,
  Users,
  Utensils,
  UtensilsCrossed,
  Warehouse,
  WashingMachine,
  Waves,
  Wifi,
  Wine,
  Wrench,
  Zap,
} from "lucide";
import type { HotspotType } from "@andarama/schema";

/**
 * Iconografia SVG del visor (lucide, licencia ISC). Nunca emojis.
 * IconNode: [tag, attrs][]
 */
export type IconNode = [string, Record<string, string>][];

const REGISTRY: Record<string, IconNode> = {
  "arrow-down": ArrowDown as IconNode,
  "arrow-left": ArrowLeft as IconNode,
  "arrow-right": ArrowRight as IconNode,
  "arrow-up": ArrowUp as IconNode,
  "arrow-up-right": ArrowUpRight as IconNode,
  "audio-lines": AudioLines as IconNode,
  "book-open": BookOpen as IconNode,
  "building-2": Building2 as IconNode,
  camera: Camera as IconNode,
  coffee: Coffee as IconNode,
  eye: Eye as IconNode,
  "flask-conical": FlaskConical as IconNode,
  footprints: Footprints as IconNode,
  "graduation-cap": GraduationCap as IconNode,
  landmark: Landmark as IconNode,
  "log-in": LogIn as IconNode,
  "log-out": LogOut as IconNode,
  star: Star as IconNode,
  trees: Trees as IconNode,
  box: Box as IconNode,
  "columns-2": Columns2 as IconNode,
  "door-open": DoorOpen as IconNode,
  "external-link": ExternalLink as IconNode,
  "file-text": FileText as IconNode,
  "gallery-horizontal-end": GalleryHorizontalEnd as IconNode,
  globe: Globe as IconNode,
  "circle-help": CircleHelp as IconNode,
  image: ImageIcon as IconNode,
  info: Info as IconNode,
  "clipboard-list": ClipboardList as IconNode,
  "map-pin": MapPin as IconNode,
  "message-square": MessageSquare as IconNode,
  pentagon: Pentagon as IconNode,
  play: Play as IconNode,
  text: Text as IconNode,
  "toggle-left": ToggleLeft as IconNode,
  video: Video as IconNode,
  "volume-2": Volume2 as IconNode,
  navigation: Navigation as IconNode,
  "arrow-up-left": ArrowUpLeft as IconNode,
  "arrow-down-right": ArrowDownRight as IconNode,
  "arrow-down-left": ArrowDownLeft as IconNode,
  "corner-up-right": CornerUpRight as IconNode,
  "corner-up-left": CornerUpLeft as IconNode,
  "chevrons-up": ChevronsUp as IconNode,
  "door-closed": DoorClosed as IconNode,
  compass: Compass as IconNode,
  route: Route as IconNode,
  signpost: Signpost as IconNode,
  milestone: Milestone as IconNode,
  map: Map as IconNode,
  home: Home as IconNode,
  hotel: Hotel as IconNode,
  church: Church as IconNode,
  castle: Castle as IconNode,
  warehouse: Warehouse as IconNode,
  factory: Factory as IconNode,
  store: Store as IconNode,
  school: School as IconNode,
  hospital: Hospital as IconNode,
  tent: Tent as IconNode,
  library: Library as IconNode,
  "tree-pine": TreePine as IconNode,
  "flower-2": Flower2 as IconNode,
  mountain: Mountain as IconNode,
  waves: Waves as IconNode,
  sun: Sun as IconNode,
  moon: Moon as IconNode,
  umbrella: Umbrella as IconNode,
  snowflake: Snowflake as IconNode,
  droplet: Droplet as IconNode,
  flame: Flame as IconNode,
  zap: Zap as IconNode,
  car: Car as IconNode,
  bus: Bus as IconNode,
  bike: Bike as IconNode,
  "train-front": TrainFront as IconNode,
  plane: Plane as IconNode,
  ship: Ship as IconNode,
  fuel: Fuel as IconNode,
  "bed-double": BedDouble as IconNode,
  bath: Bath as IconNode,
  "shower-head": ShowerHead as IconNode,
  sofa: Sofa as IconNode,
  armchair: Armchair as IconNode,
  lamp: Lamp as IconNode,
  utensils: Utensils as IconNode,
  "utensils-crossed": UtensilsCrossed as IconNode,
  "cooking-pot": CookingPot as IconNode,
  refrigerator: Refrigerator as IconNode,
  microwave: Microwave as IconNode,
  "washing-machine": WashingMachine as IconNode,
  wine: Wine as IconNode,
  "cup-soda": CupSoda as IconNode,
  pizza: Pizza as IconNode,
  apple: Apple as IconNode,
  "shopping-cart": ShoppingCart as IconNode,
  gift: Gift as IconNode,
  ticket: Ticket as IconNode,
  "key-round": KeyRound as IconNode,
  lock: Lock as IconNode,
  bell: Bell as IconNode,
  clock: Clock as IconNode,
  calendar: Calendar as IconNode,
  wrench: Wrench as IconNode,
  hammer: Hammer as IconNode,
  lightbulb: Lightbulb as IconNode,
  "trash-2": Trash2 as IconNode,
  recycle: Recycle as IconNode,
  package: Package as IconNode,
  printer: Printer as IconNode,
  wifi: Wifi as IconNode,
  phone: Phone as IconNode,
  monitor: Monitor as IconNode,
  tv: Tv as IconNode,
  "gamepad-2": Gamepad2 as IconNode,
  music: Music as IconNode,
  mic: Mic as IconNode,
  headphones: Headphones as IconNode,
  guitar: Guitar as IconNode,
  piano: Piano as IconNode,
  palette: Palette as IconNode,
  brush: Brush as IconNode,
  drama: Drama as IconNode,
  newspaper: Newspaper as IconNode,
  film: Film as IconNode,
  clapperboard: Clapperboard as IconNode,
  telescope: Telescope as IconNode,
  binoculars: Binoculars as IconNode,
  users: Users as IconNode,
  user: User as IconNode,
  "person-standing": PersonStanding as IconNode,
  accessibility: Accessibility as IconNode,
  baby: Baby as IconNode,
  heart: Heart as IconNode,
  "heart-pulse": HeartPulse as IconNode,
  stethoscope: Stethoscope as IconNode,
  cross: Cross as IconNode,
  shield: Shield as IconNode,
  siren: Siren as IconNode,
  "fire-extinguisher": FireExtinguisher as IconNode,
  "alert-triangle": AlertTriangle as IconNode,
  ban: Ban as IconNode,
  dog: Dog as IconNode,
  cat: Cat as IconNode,
  bird: Bird as IconNode,
  fish: Fish as IconNode,
  "paw-print": PawPrint as IconNode,
  bug: Bug as IconNode,
  rabbit: Rabbit as IconNode,
  turtle: Turtle as IconNode,
  trophy: Trophy as IconNode,
  medal: Medal as IconNode,
  crown: Crown as IconNode,
  rocket: Rocket as IconNode,
  sparkles: Sparkles as IconNode,
  flag: Flag as IconNode,
  gem: Gem as IconNode,
  ghost: Ghost as IconNode,
  puzzle: Puzzle as IconNode,
  "dice-5": Dice5 as IconNode,
};

/** Permite a la skin (u otros consumidores) registrar iconos adicionales. */
export function registerIcons(icons: Record<string, IconNode>): void {
  Object.assign(REGISTRY, icons);
}

/** ¿Sabe el visor dibujar este icono? El editor lo usa para no ofrecer
 *  nombres que acabarían cayendo en el icono de reserva. */
export function hasIcon(name: string): boolean {
  return name in REGISTRY;
}

export const DEFAULT_ICON_BY_TYPE: Record<HotspotType, string> = {
  navigation: "arrow-up",
  text: "text",
  image: "image",
  gallery: "gallery-horizontal-end",
  videoFile: "video",
  embedVideo: "play",
  audio: "volume-2",
  pdf: "file-text",
  model3d: "box",
  web: "globe",
  form: "clipboard-list",
  compare: "columns-2",
  quiz: "circle-help",
  polygon: "pentagon",
  tooltip: "message-square",
  link: "external-link",
  // El mismo icono que la paleta del Studio (interruptor: cambia una variable)
  state: "toggle-left",
  treasure: "gem",
};

const SVG_NS = "http://www.w3.org/2000/svg";

export function createIconSvg(name: string, size = 24, color = "currentColor"): SVGSVGElement {
  const node = REGISTRY[name] ?? REGISTRY.info!;
  const svg = document.createElementNS(SVG_NS, "svg");
  svg.setAttribute("viewBox", "0 0 24 24");
  svg.setAttribute("width", String(size));
  svg.setAttribute("height", String(size));
  svg.setAttribute("fill", "none");
  svg.setAttribute("stroke", color);
  svg.setAttribute("stroke-width", "2");
  svg.setAttribute("stroke-linecap", "round");
  svg.setAttribute("stroke-linejoin", "round");
  svg.setAttribute("aria-hidden", "true");
  for (const [tag, attrs] of node) {
    const el = document.createElementNS(SVG_NS, tag);
    for (const [k, v] of Object.entries(attrs)) el.setAttribute(k, String(v));
    svg.appendChild(el);
  }
  return svg;
}

/** Saneado minimo de SVG propio de autor: elimina scripts y manejadores. */
export function sanitizeSvg(svgMarkup: string): string {
  const doc = new DOMParser().parseFromString(svgMarkup, "image/svg+xml");
  const svg = doc.documentElement;
  if (svg.nodeName.toLowerCase() !== "svg") return "";
  const walk = (el: Element): void => {
    for (const child of [...el.children]) {
      const tag = child.tagName.toLowerCase();
      if (tag === "script" || tag === "foreignobject" || tag === "iframe") {
        child.remove();
        continue;
      }
      for (const attr of [...child.attributes]) {
        const n = attr.name.toLowerCase();
        if (n.startsWith("on") || (n === "href" && attr.value.trim().toLowerCase().startsWith("javascript:")) ||
            (n === "xlink:href" && attr.value.trim().toLowerCase().startsWith("javascript:"))) {
          child.removeAttribute(attr.name);
        }
      }
      walk(child);
    }
  };
  for (const attr of [...svg.attributes]) {
    if (attr.name.toLowerCase().startsWith("on")) svg.removeAttribute(attr.name);
  }
  walk(svg);
  return new XMLSerializer().serializeToString(svg);
}
